import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import PaymentJourneyMessage from '../PaymentJourneyMessage/PaymentJourneyMessage';
import BaseSectionTitle from '../../siteBaseSections/baseSectionComponents/BaseSectionTitle/BaseSectionTitle';
import BaseSectionText from '../../siteBaseSections/baseSectionComponents/BaseSectionText/BaseSectionText';
import BaseSectionCTA from '../../siteBaseSections/baseSectionComponents/BaseSectionCTA/BaseSectionCTA';

export function OrderNotFoundSection({ t }) {
  const emailAddress = 'conferencecustomerservices@informa.com';

  return (
    <PaymentJourneyMessage
      header={<BaseSectionTitle text={t('event.purchase.order-not-found')} />}
      body={
        <BaseSectionText
          text={
            <Trans
              i18nKey="event.purchase.order-not-found.instructions"
              values={{ email: emailAddress }}
            >
              <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </Trans>
          }
          jsx
        />
      }
      footer={<BaseSectionCTA primary={{ type: 'BUY_LINK' }} mode="black" />}
    />
  );
}

export default withTranslation()(OrderNotFoundSection);
